/**
 * Roll up all form values into a JS object.
 * Allows for nesting via ., ie person.address.street
 * Note that duplicate keys will use the last one
 * @param {HTMLFormElement} form
 */
export function FormToObject(form) {
    const formdata = new FormData(form);
    const data = {};
    const braceRegex = /{([^}]+)}/;
    formdata.forEach((value, key) => {
        const input = form.querySelector("[name='" + key + "'");
        if (input.hasAttribute("data-form-helper-json")) {
            // This field has been marked to be interpreted as JSON
            value = JSON.parse(value);
        }
        const parts = key.split(".");
        let cursor = data;
        for (let i = 0; i < parts.length; i++) {
            if (i === parts.length - 1) {
                cursor[parts[i]] = value;
            } else {
                const match = braceRegex.exec(parts[i]);
                if (match) {
                    // Special handling for curly braces. A field like Instructions{asdf} will become an array (Instructions[]) with an element { Id = "asdf" }
                    parts[i] = parts[i].substring(0, match.index);
                    if (!Array.isArray(cursor[parts[i]])) {
                        cursor[parts[i]] = [];
                    }
                    const item = { Id: match[1] };
                    cursor[parts[i]].push(item);
                    cursor = item;
                } else {
                    // No braces, handle as normal
                    if (typeof cursor[parts[i]] !== "object") {
                        cursor[parts[i]] = {};
                    }
                    cursor = cursor[parts[i]];
                }
            }
        }
    });
    return data;
}
